import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TaxonomyFunctionItem } from './taxonomyTypes';

export type TaxonomyState = {
  data: TaxonomyFunctionItem[];
  loading: boolean;
  error: string | null;
};

const initialState: TaxonomyState = {
  data: [],
  loading: false,
  error: null,
};

export const taxonomySlice = createSlice({
  name: 'taxonomy',
  initialState,
  reducers: {
    setTaxonomies: (state, action: PayloadAction<TaxonomyFunctionItem[]>) => {
      state.data = action.payload;
    },
    resetTaxonomies: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const { resetTaxonomies, setTaxonomies } = taxonomySlice.actions;
export default taxonomySlice.reducer;
